import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  from,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";
import { isSupportView, supportToken } from "./support-session";
import { RestLink } from "apollo-link-rest";

import {
  authenticationStateVar,
  resetAuthenticationState,
} from "@/apollo/auth-state";
import { env } from "@/lib/env";

const httpLink = new HttpLink({
  uri: env.skedLinkBackendApiUrl,
  credentials: "include",
});

const restLink = new RestLink({
  uri: env.schedugramServerBackendUrl || "http://localhost:3000",
}) as unknown as ApolloLink;

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (
    networkError &&
    "statusCode" in networkError &&
    networkError.statusCode === 401
  ) {
    resetAuthenticationState();
    return;
  }
  if (!graphQLErrors) return;
  for (const { message } of graphQLErrors) {
    if (message.includes("Not authenticated")) {
      resetAuthenticationState();
      return;
    }
  }
});

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        authenticationState: {
          read() {
            return authenticationStateVar();
          },
        },
      },
    },
  },
});

export const apolloClient = new ApolloClient({
  cache,
  link: from([
    errorLink,
    setContext(async (_, context) =>
      isSupportView
        ? {
            headers: {
              ...context.headers,
              Authorization: `Bearer ${await supportToken()}`,
            },
            credentials: "omit",
          }
        : {}
    ),
    restLink,
    httpLink,
  ]),
});
